/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from 'react'
import debounce from 'lodash/debounce'

export const DEFAULT_CHANGE_HANDLER = () => null
interface Params {
  value: boolean
  onChange?: (value: boolean) => void
}

const useToggle = ({ value, onChange = DEFAULT_CHANGE_HANDLER }: Params) => {
  const [toggled, setToggled] = useState(value)

  const handleClick = useCallback(
    debounce(
      () => {
        setToggled(prev => !prev)
        onChange(toggled)
      },
      500,
      {
        leading: true,
        trailing: false,
      }
    ),
    [onChange]
  )

  useEffect(() => {
    if (value === toggled) return

    setToggled(value)
  }, [value])

  useEffect(() => {
    return () => {
      handleClick.cancel()
    }
  }, [])

  return {
    value: toggled,
    toggle: handleClick,
  }
}

export default useToggle
